import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router) {}

  async canActivate(route: any): Promise<boolean> {
    // Check if the user token is present
    const token = localStorage.getItem('bbq_token')?.toString();
    // If no token, redirect to login page
    if (!token) {
      // console.log(token)
      this.router.navigate(['/']);
      return false;
    }
  }
}
